import { addLineBreaksAsHTML } from '@fhnw/helpers/text/addLineBreaks';
import containsHTML from '@fhnw/helpers/text/containsHTML';
import { sanitizeBasicFormatting } from '@designsystem/utils/sanitize';

const RichText = ({ text }: { text: string }) => {
  text = addLineBreaksAsHTML(text);
  if (containsHTML(text)) {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: sanitizeBasicFormatting(text) }}
      />
    );
  }

  return <>{text}</>;
};

export default RichText;
